import React, { useState, useEffect } from 'react';
import SelectOutlined from 'libraries/Select';
import { getAssessmentCategories } from 'requests/ScriptRequests';

const showAllOption = {
    value: 'all',
    label: 'Show All'
};
const CategoriesDropdown = ({ selectedCategory, setCategory, setQuery }) => {
    const [menuOptions, setMenuOptions] = useState([]);

    useEffect(() => {
        getAssessmentCategories()
            .then((data) => {
                if (data && data.length) {
                    setMenuOptions([
                        showAllOption,
                        ...data.map(category => ({
                            value: category.uuid,
                            label: category.title
                        }))
                    ]);
                }
            });
    }, []);

    const handleChangeCategory = (e) => {
        const { value } = e.target;
        setCategory(value === 'all' ? null : value);
        setQuery('');
    };

    return (
        <SelectOutlined
            disabled={!menuOptions.length}
            className="u-mrg--bx3 u"
            variant="outlined"
            value={selectedCategory || 'all'}
            onChange={handleChangeCategory}
            label="Category"
            options={menuOptions}
        />
    );
};

export default CategoriesDropdown;
